import React from "react";
import { connect } from "react-redux";
import { AppState } from "src/redux/store";
import * as State from "src/redux/projects/state";
import {
  getProposal,
  getProject,
  getPrestation
} from "src/redux/projects/selectors";
import { PovContainer } from "./PovContainer";
import { ArtworkContainer } from "./ArtworkContainer";
import * as StateCurrentResponses from "src/redux/currentResponses/state";
import * as Project from "src/redux/projects";
import * as CurrentReponses from "src/redux/currentResponses";
import { PlanDecorationContainer } from "./PlanDecorationContainer";
import * as Stories from "src/redux/stories";
import { withNamespaces, WithNamespaces } from "react-i18next";
import { toast } from "react-toastify";
import history from "src/plugins/history";
import AlertDevisModal from "../components/AlertDevisModal";


interface Props {
  projectId: number;
  proposalUuid: string;
  prestationId: number;
}
function mapStateToProps(state: AppState, props: Props) {
  return {
    project: getProject(state.projects, props),
    profil: state.user.profil,
    prestation: getPrestation(state.projects, props),
    proposal: getProposal(state.projects, props),
    currentReponses: state.currentReponses
      .currentResponses as StateCurrentResponses.CurrentResponse[]
  };
}
function mapDispatchToProps(dispatch) {
  return {
    submitResponse: (
      projectId: number,
      prestationId: number,
      proposal: State.Proposal,
      response: State.GenericalResponse,
      share?: boolean
    ) =>
      dispatch(
        Project.submitResponse(
          projectId,
          prestationId,
          proposal,
          response,
          share
        )
      ),
    loadProposal: (
      projectId: number,
      prestationId: number,
      proposalUuid: string
    ) =>
      dispatch(
        Stories.fetchProposalOnce(projectId, prestationId, proposalUuid)
      ),
    removeCurrentProposalResponse: (proposalUuid: string) =>
      dispatch(CurrentReponses.removeCurrentProposalResponse(proposalUuid))
  };
}
type PropsWithMapState = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  Props &
  WithNamespaces;

class ProposalContainerToConnect extends React.Component<PropsWithMapState> {
  state={
    showDevisModal: false
  }
  async componentWillMount() {
    try {
      await this.props.loadProposal(
        this.props.projectId,
        this.props.prestationId,
        this.props.proposalUuid
      );
    } catch (error) {
      console.error(error);
    }
  }

  handleSubmitProposal = async (
    response: State.GenericalResponse,
    share?: boolean,
    newDevis?: boolean
  ) => {
    if (!response || !this.props.proposal) {
      return;
    }
    try {
      await this.props.submitResponse(
        this.props.projectId,
        this.props.prestationId,
        this.props.proposal,
        response,
        share
      );
      if (!share) {
        this.props.removeCurrentProposalResponse(this.props.proposalUuid);
        if(!newDevis) {
          history.push({
            pathname: `/projects/${this.props.projectId}`,
            state: {projectId: `${this.props.projectId}`}
          });
        } else {
          this.setState({showDevisModal:true});
        }
      }
      toast.success(this.props.t("success.updated"));
    } catch (e) {
      toast.error(this.props.t("error.unknown"));
      console.error(e);
    }
  };

  renderComponent = () => {
    if (!this.props.proposal || !this.props.project || !this.props.prestation || !this.props.proposal.responses.length) {
      if(this.state.showDevisModal){
        return <AlertDevisModal projectId={this.props.projectId}/>
      } else {
        return null;
      }
    }
    switch (this.props.proposal.type) {
      case State.ProposalType.POV:
        return (
          <PovContainer
            proposal={this.props.proposal}
            projectId={this.props.projectId}
            prestationId={this.props.prestationId}
            prestationName={this.props.prestation.name}
            currentResponses={this.props.currentReponses}
            projectName={this.props.project.name}
            profil={this.props.profil}
            handleSubmitProposal={this.handleSubmitProposal}
          />
        );
      case State.ProposalType.Artwork:
        return (
          <ArtworkContainer
            proposal={this.props.proposal}
            prestationName={this.props.prestation.name}
            projectName={this.props.project.name}
            profil={this.props.profil}
            currentResponses={this.props.currentReponses}
            handleSubmitProposal={this.handleSubmitProposal}
          />
        );
      case State.ProposalType.PlanDecoration:
        return (
          <PlanDecorationContainer
            prestationName={this.props.prestation.name}
            proposal={this.props.proposal}
            projectName={this.props.project.name}
            projectId={this.props.projectId}
            profil={this.props.profil}
            prestationId={this.props.prestationId}
            currentResponses={this.props.currentReponses}
            handleSubmitProposal={this.handleSubmitProposal}
          />
        );
      default:
        return null;
    }
  };

  render() {
    return this.renderComponent();
  }
}

export const ProposalContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(ProposalContainerToConnect));



// WEBPACK FOOTER //
// ./src/containers/ProposalContainer.tsx